<template>
    <button
        class="btn"
        v-bind="$attrs"
        :class="btnClass"
        :disabled="isDisabled || isLoading"
    >
        <template v-if="isLoading">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            {{ $t(loadingText) }}
        </template>
        <slot v-else />
    </button>
</template>

<script setup>
import { defineProps, ref } from "vue";
import {trans as $t} from "@/vue/composables/missingTranslations";

const props = defineProps({
    isLoading: {
        type: Boolean,
        default: false
    },
    isDisabled: {
        type: Boolean,
        default: false
    },
    btnClass: {
        type: String,
        default: "btn-primary"
    },
    loadingText: {
        type: String,
        default: "Loading..."
    }
});

const loadingText = ref(props.loadingText);

</script>
